// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Bank$OrcaPaymentPage from "../Bank.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as EmailField$OrcaPaymentPage from "./DynamicFields/EmailField.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PhoneField$OrcaPaymentPage from "./DynamicFields/PhoneField.bs.js";
import * as DateOfBirth$OrcaPaymentPage from "../Payments/DateOfBirth.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";
import * as GenericInputField$OrcaPaymentPage from "./DynamicFields/GenericInputField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";
import * as StateDropdownField$OrcaPaymentPage from "./DynamicFields/StateDropdownField.bs.js";
import * as CardHolderNameField$OrcaPaymentPage from "./DynamicFields/CardHolderNameField.bs.js";
import * as BankNamesSelectField$OrcaPaymentPage from "./DynamicFields/BankNamesSelectField.bs.js";
import * as CountryDropdownField$OrcaPaymentPage from "./DynamicFields/CountryDropdownField.bs.js";
import * as GenericDropdownField$OrcaPaymentPage from "./DynamicFields/GenericDropdownField.bs.js";
import * as CryptoCurrencyNetworks$OrcaPaymentPage from "./CryptoCurrencyNetworks.bs.js";
import * as PhoneCountryCodeDropdownField$OrcaPaymentPage from "./DynamicFields/PhoneCountryCodeDropdownField.bs.js";

function groupFieldsByRow(fields) {
  var rows = [];
  var rowMap = {};
  fields.forEach(function (field) {
        var rowId = field.layoutRowId;
        if (rowId !== undefined) {
          var row = rowMap[rowId];
          if (row !== undefined) {
            row.push(field);
            return ;
          }
          var row$1 = [field];
          rowMap[rowId] = row$1;
          rows.push(row$1);
          return ;
        }
        rows.push([field]);
      });
  return rows;
}

function renderSingleField(field, allFields, paymentMethodType, isLabelHiddenOpt, globalEmailFields, globalCardHolderNameFields) {
  var isLabelHidden = isLabelHiddenOpt !== undefined ? isLabelHiddenOpt : false;
  var match = field.fieldRenderType;
  switch (match) {
    case "Phone" :
        return React.createElement(PhoneField$OrcaPaymentPage.make, {
                    fieldConfig: field,
                    isLabelHidden: isLabelHidden
                  });
    case "Email" :
        var allEmailFields = Core__Option.getOr(globalEmailFields, []);
        var firstEmailPath = Core__Option.map(allEmailFields[0], (function (f) {
                return f.confirmRequestWritePath;
              }));
        return React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: firstEmailPath === field.confirmRequestWritePath,
                    children: React.createElement(EmailField$OrcaPaymentPage.make, {
                          fields: allEmailFields
                        })
                  });
    case "CardHolderName" :
        var allCardHolderNameFields = globalCardHolderNameFields !== undefined ? globalCardHolderNameFields : [];
        var firstCardHolderNamePath = Core__Option.map(allCardHolderNameFields[0], (function (field) {
                return field.confirmRequestWritePath;
              }));
        return React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: firstCardHolderNamePath === field.confirmRequestWritePath,
                    children: React.createElement(CardHolderNameField$OrcaPaymentPage.make, {
                          fields: allCardHolderNameFields
                        })
                  });
    case "PhoneCountryCode" :
        return React.createElement(PhoneCountryCodeDropdownField$OrcaPaymentPage.make, {
                    fieldConfig: field,
                    isLabelHidden: isLabelHidden
                  });
    case "Generic" :
    case "FirstName" :
    case "LastName" :
        return React.createElement(GenericInputField$OrcaPaymentPage.make, {
                    fieldConfig: field
                  });
    case "Dropdown" :
    case "CryptoCurrency" :
        break;
    case "CryptoNetwork" :
        var currencyField = DynamicFieldsUtils$OrcaPaymentPage.findCryptoCurrencyField(allFields);
        if (currencyField !== undefined) {
          return React.createElement(CryptoCurrencyNetworks$OrcaPaymentPage.make, {
                      networkField: field,
                      currencyField: currencyField
                    });
        } else {
          return null;
        }
    case "Date" :
    case "DateOfBirth" :
        return React.createElement(DateOfBirth$OrcaPaymentPage.make, {
                    fieldConfig: field
                  });
    case "State" :
        return React.createElement(StateDropdownField$OrcaPaymentPage.make, {
                    fieldConfig: field
                  });
    case "Country" :
        var isoCodes = Core__Option.getOr(field.dropdownOptions, []);
        var options = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(Utils$OrcaPaymentPage.isoOptionsToCountryNames(isoCodes));
        return React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: options.length > 0,
                    children: React.createElement(CountryDropdownField$OrcaPaymentPage.make, {
                          fieldConfig: field,
                          options: options
                        })
                  });
    case "BankNamesSelect" :
        var allowedValues = Core__Option.getOr(field.dropdownOptions, []);
        var banks = Bank$OrcaPaymentPage.getBanks(paymentMethodType);
        var options$1 = allowedValues.map(function (bankValue) {
              var label = Core__Option.getOr(Core__Option.map(banks.find(function (bank) {
                            return bank.value === bankValue;
                          }), (function (bank) {
                          return bank.displayName;
                        })), bankValue);
              return {
                      value: bankValue,
                      label: label
                    };
            });
        return React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: options$1.length > 0,
                    children: React.createElement(BankNamesSelectField$OrcaPaymentPage.make, {
                          fieldConfig: field,
                          options: options$1
                        })
                  });
    default:
      return null;
  }
  var options$2 = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(Core__Option.getOr(field.dropdownOptions, []));
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: options$2.length > 0,
              children: React.createElement(GenericDropdownField$OrcaPaymentPage.make, {
                    fieldConfig: field,
                    options: options$2
                  })
            });
}

function renderRowLabel(label, themeObj) {
  return React.createElement("div", {
              "aria-hidden": true,
              className: "Label",
              style: {
                fontSize: themeObj.fontSizeLg,
                fontWeight: themeObj.fontWeightNormal,
                marginBottom: "5px",
                opacity: "0.6"
              }
            }, label);
}

function DynamicFieldInput$makeRow(props) {
  var globalCardHolderNameFields = props.globalCardHolderNameFields;
  var globalEmailFields = props.globalEmailFields;
  var paymentMethodType = props.paymentMethodType;
  var allFields = props.allFields;
  var items = props.items;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var config = match.config;
  var match$1 = items.length;
  if (match$1 === 0) {
    return null;
  }
  if (match$1 !== 1) {
    var isCombinedPhoneRow = DynamicFieldsUtils$OrcaPaymentPage.isCombinedPhoneRow(items);
    var rowLabel = isCombinedPhoneRow ? DynamicFieldsUtils$OrcaPaymentPage.getCombinedPhoneRowLabel(items, match.localeString) : "";
    var showRowLabel = isCombinedPhoneRow && rowLabel.length > 0 && config.appearance.labels === "Above" && config.appearance.innerLayout === "Spaced";
    return React.createElement(React.Fragment, {}, React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: showRowLabel,
                    children: renderRowLabel(rowLabel, match.themeObj)
                  }), React.createElement("div", {
                    className: "flex gap-4 w-full"
                  }, items.map(function (field, i) {
                        return React.createElement("div", {
                                    key: field.confirmRequestWritePath + "-" + i.toString(),
                                    className: "flex-1 min-w-0",
                                    style: {
                                      flexGrow: Core__Option.getOr(field.layoutWidthRatio, 1.0).toString()
                                    }
                                  }, renderSingleField(field, allFields, paymentMethodType, showRowLabel, globalEmailFields, globalCardHolderNameFields));
                      })));
  }
  var field = items[0];
  if (field !== undefined) {
    return renderSingleField(field, allFields, paymentMethodType, undefined, globalEmailFields, globalCardHolderNameFields);
  } else {
    return null;
  }
}

var makeRow = DynamicFieldInput$makeRow;

export {
  groupFieldsByRow ,
  renderSingleField ,
  renderRowLabel ,
  makeRow ,
}
/* jotai Not a pure module */
